export const TOOLTIP_PROTAL_ID = 'onboarding-tooltip-portal';
export const DASHBOARD_EDIT_PAGE_LABEL = 'dashboardEdit';
export const DASHBOARD_LIBRARY_PAGE_LABEL = 'dashboardLibrary';
export const HEADER_SECTION = 'header';
export const SIDEBAR_SECTION = 'sidebar';
export const WIDGET_SECTION = 'widget';
export const DASHBOARD_ITEM_SECTION = 'dashboardItem';
export const DASHBOARD_LIST_ITEM_SECTION = 'dashboardListItem';
export const DASHBOARD_FILTER_SECTION = 'dashboardFilter';
export const PAGE_STEPS_NUMBER = 'pageStepsNumber';

const TOOLTIP_WIDTH = 280;

export const TOOLTIPS = {
  [DASHBOARD_EDIT_PAGE_LABEL]: {
    [PAGE_STEPS_NUMBER]: 6,
    [HEADER_SECTION]: [
      {
        text: 'Click to add widgets to your dashboard',
        tooltipId: 'addWidget',
        position: {
          x: 'left',
          y: 'bottom',
        },
        arrowPosition: 'top',
        step: 1,
        adjust: {
          x: -80,
          y: -30,
        },
      },
      {
        text: 'Add this dashboard to your favorites in the Dashboard Library',
        tooltipId: 'setAsFavorite',
        position: {
          x: 'left',
          y: 'bottom',
        },
        arrowPosition: 'top',
        step: 2,
        adjust: {
          x: -50,
          y: -30,
        },
      },
      {
        text: 'Make your dashboard private or public and share it with child organizations',
        tooltipId: 'permissionSettings',
        position: {
          x: 'left',
          y: 'bottom',
        },
        arrowPosition: 'top',
        step: 3,
        adjust: {
          x: -50,
          y: -30,
        },
      },
      {
        text: 'Clear your dashboard and start over',
        tooltipId: 'resetConfiguration',
        position: {
          x: 'left',
          y: 'bottom',
        },
        arrowPosition: 'top',
        step: 4,
        adjust: {
          x: -50,
          y: -30,
        },
      },
    ],
    [SIDEBAR_SECTION]: [
      {
        // eslint-disable-next-line max-len
        text: 'Drag and drop widgets to your dashboard. You can filter the list of widgets',
        tooltipId: 'widgets-sidebar',
        position: {
          // specify tooltip position absolute to parent x and y (left,right,top,bottom)
          x: 'left',
          y: 'top',
        },
        move: {
          // specify parent attribute for which u want to move tooltip
          x: 'width',
        },
        adjust: {
          x: -TOOLTIP_WIDTH - 60,
        },
        arrowPosition: 'right',
        step: 5,
      },
    ],
    [WIDGET_SECTION]: [
      {
        // eslint-disable-next-line max-len
        text: 'Configure your widgets, then drag and drop to reposition them on the dashboard',
        tooltipId: 'widget',
        position: {
          // specify tooltip position absolute to parent x and y (left,right,top,bottom)
          x: 'left',
          y: 'top',
        },
        adjust: {
          x: TOOLTIP_WIDTH + 110,
          y: -50,
        },
        arrowPosition: 'left',
        step: 6,
      },
    ],
  },
  [DASHBOARD_LIBRARY_PAGE_LABEL]: {
    [PAGE_STEPS_NUMBER]: 2,
    [DASHBOARD_ITEM_SECTION]: [
      {
        text: 'This allows you to configure dashboard, clone or set as favorite.',
        tooltipId: 'dashboard-options',
        position: {
          // specify tooltip position absolute to parent x and y (left,right,top,bottom)
          x: 'right',
          y: 'top',
        },
        adjust: {
          x: -(TOOLTIP_WIDTH - 240),
          y: -60,
        },
        arrowPosition: 'left',
        step: 1,
      },
    ],
    [DASHBOARD_LIST_ITEM_SECTION]: [
      {
        text: 'This allows you to configure dashboard, clone or set as favorite.',
        tooltipId: 'dashboard-options',
        position: {
          // specify tooltip position absolute to parent x and y (left,right,top,bottom)
          x: 'left',
          y: 'top',
        },
        adjust: {
          x: -(TOOLTIP_WIDTH + 60),
          y: -60,
        },
        arrowPosition: 'right',
        step: 1,
      },
    ],
    [DASHBOARD_FILTER_SECTION]: [
      {
        text: 'Click here for easy search of your or any other dashboards',
        tooltipId: 'dashboard-filter',
        position: {
          // specify tooltip position absolute to parent x and y (left,right,top,bottom)
          x: 'right',
          y: 'bottom',
        },
        move: {
          y: 'height',
        },
        adjust: {
          x: -TOOLTIP_WIDTH - 40,
        },
        arrowPosition: 'top-right',
        step: 2,
      },
    ],
  },
};
